<template>
  <div id="list_quote">
    <Header />
    <LeftNav />
    <main id="page-wrap">
      <b-container fluid>
        <FilterBar />
        <ProposalListTable ref="proposalListTableRef"/>
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/layout/AppHeader.vue";
import Footer from "@/components/common/layout/AppFooter.vue";
import ProposalListTable from "@/components/proposal/ProposalListTable.vue";
import LeftNav from "@/components/common/layout/AppLeftNav";
import FilterBar from "@/components/vuetable/ProposalFilterBar.vue";

export default {
  name: "list_workflow",
  components: {
    Header,
    Footer,
    ProposalListTable,
    LeftNav,
    FilterBar
  }
};
</script>

<style scoped>
.row-top-list {
  margin-top: 40px;
}
</style>

<i18n>
{
  "en": {
    "search_panel": "Search Panel",
    "list_quotaion": "Quotation List"
  },
  "si": {
    "search_panel": "සෙවුම් පැනලය",
    "list_quotaion": "ලැයිස්තු උපුටා දැක්වීම"
  }
}
</i18n>
